<div class="license-lock-backdrop" [class.license-lock-backdrop--contained]="contained" role="presentation">
  <div class="license-lock-content" role="dialog" aria-modal="true">
    <div class="license-lock-scroll">
      <div class="lock-icon">
        <i class="material-symbols-rounded filled">lock</i>
      </div>
      <div>
        <h2 class="title mb-2">{{ title }}</h2>
        <p class="text" [innerHTML]="text"></p>
        <p class="license-lock-checklist-title">{{ 'pap/lock/description' | transloco }}</p>
        <ul class="license-lock-checklist">
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/professionalPortfolio' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/educationActivityRecords' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/certificateUploads' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/lecturerInfo' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/selfReflection' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/furtherEducationPlanning' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/selfEvaluation' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/recommendations' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/trainingMediaAndNotes' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/sharingWithManagement' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/printableReports' | transloco }}</span>
          </li>
          <li class="license-lock-checklist-item">
            <i class="material-symbols-rounded filled">check</i>
            <span>{{ 'pap/lock/features/clearTables' | transloco }}</span>
          </li>
        </ul>
      </div>
      <div class="license-lock-cta-group">
        <a
          *ngIf="showPricingCta"
          class="btn btn-primary w-100 license-lock-cta"
          [href]="managementPricingUrl.url"
          [target]="managementPricingUrl.target"
        >
          {{ 'pap/lock/ctaPricing' | transloco }}
        </a>
        <a
          class="btn btn-outline-primary w-100 license-lock-cta license-lock-secondary-cta"
          href="https://isophi.cz/konzultace/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ 'pap/lock/ctaConsultation' | transloco }}
        </a>
      </div>
      <div class="license-lock-note">
        <i class="material-symbols-rounded filled">info</i>
        {{ 'pap/lock/note' | transloco }}
      </div>
    </div>
  </div>
</div>
